import React, { useEffect } from "react";
import FancyWeddingCountdownTimer from "./countdown";
import { useLocation } from "react-router-dom";
import Timelines from "./Timeline";
import FamilyTree from "./family-tree";
import Invitors from "./invitors";
import RSVPSection from "./rsvp_section";
import { Link } from "@mui/material";
import { BsInstagram } from "react-icons/bs";
import LocationShowcase from "./Location";

const developers = [
  {
    name: "Tirthrajsinh Zala",
    instagramUrl: "https://www.instagram.com/tirthraj_sinh_zala/",
  },
  {
    name: "Ishan Ladva",
    instagramUrl: "https://www.instagram.com/ishanladva/",
  },
  {
    name: "Kushal Master",
    instagramUrl: "https://www.instagram.com/kushal0189/",
  },
];

const Content = () => {
  // Extract query parameters
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const name = params.get("name"); // Get the 'name' parameter

  useEffect(() => {
    const fadeOutTimeout = setTimeout(() => {
      document.getElementById("preloader")?.classList.add("fade-out");
    }, 2000); // Start fade-out after 2 seconds

    const removeTimeout = setTimeout(() => {
      document.getElementById("preloader").style.display = "none";
    }, 4000); // Remove preloader after 4 seconds

    return () => {
      clearTimeout(fadeOutTimeout);
      clearTimeout(removeTimeout);
    };
  }, []);

  return (
    <div>
      <div id="preloader">
        <div class="preloader pulse">
          <h3>તીર્થરાજસિંહ</h3>
          <h3>અને</h3>
          <h3>ભવ્યતાબા</h3>
          <div className="lifeline">
            <div className="lifeline-pulse"></div>
          </div>
        </div>
      </div>
      <div class="home-slider">
        <ul class="rslides">
          <li>
            <img src="images/tirthraj2.jpeg" alt="🧿, jaymataji, jayshreeswaminarany, jay hanumanjij" />
          </li>
        </ul>
        <div class="lbox-details">
          <FancyWeddingCountdownTimer guestName={name} />
        </div>
      </div>

      <Timelines />

      <Invitors />

      <RSVPSection guestName={name}> </RSVPSection>
      <FamilyTree />
      <LocationShowcase/>


      <footer class="footer-box">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <p class="footer-company-name">
                All Rights Reserved. &copy; 2025
              </p>
              <p class="footer-company-name">Developed By</p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "4px",
                  alignItems: "center",
                }}
              >
                {developers.map((developer, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexGrow: index !== 1 ? "1" : "0",
                      justifyContent: index === 0 ? "start" : "end",
                    }}
                  >
                    <span
                      style={{ color: "white" }}
                      className="text-sm font-medium"
                    >
                      {developer.name}
                    </span>
                    <Link
                      href={developer.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <BsInstagram />
                      <span className="sr-only">
                        Instagram for {developer.name}
                      </span>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Content;
